<template>
  <section class="services">
    <!-- Title -->
    <div class="services__title">
      {{ $t("services_1") }}
    </div>

    <!-- Subtitle -->
    <div class="services__subtitle">
      {{ $t("services_2_1") }}
    </div>

    <!-- Services -->
    <div class="services__content">
      <!-- Mobile Apps -->
      <services-item-view>
        <template slot="icon">
          <icon-mobile-apps-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_11") }}
        </template>
      </services-item-view>

      <!-- Web Based Tools -->
      <services-item-view>
        <template slot="icon">
          <icon-web-based-tools-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_12") }}
        </template>
      </services-item-view>

      <!-- IOT -->
      <services-item-view>
        <template slot="icon">
          <icon-iot-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_13") }}
        </template>
      </services-item-view>

      <!-- Ecommerce -->
      <services-item-view>
        <template slot="icon">
          <icon-ecommerce-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_14") }}
        </template>
      </services-item-view>
    </div>

    <!-- Action -->
    <div class="services__action">
      <router-link :to="{ name: 'work_index' }">
        <button-view>
          {{ $t("button_4") }}
        </button-view>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Services',

  components: {
    ServicesItemView: () => import('./services-item-view'),
    IconMobileAppsView: () => import('@/icons/icon-mobile-apps-view'),
    IconWebBasedToolsView: () => import('@/icons/icon-web-based-tools-view'),
    IconIotView: () => import('@/icons/icon-iot-view'),
    IconEcommerceView: () => import('@/icons/icon-ecommerce-view'),
    ButtonView: () => import('@/components/button/button-view')
  },

  mounted() {}
};
</script>

<style
  lang="scss"
  src="@/assets/components/services/services-view.scss"
></style>



// WEBPACK FOOTER //
// services-view.vue